export class User {
  secretQuestion: string;
  secretQuestion2: string;
  secretQuestion3: string;
  secretQuestionAnswer: string;
  secretQuestionAnswer2: string;
  secretQuestionAnswer3: string;
  newEmail: string;
  uid: string;
  userPassword: string;
  confirmPassword: string;
  edeliveryflag: string;
}

